/** @format */

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import utils from './../util';
import { apiPerfil } from '../api';
import Constantes from '../util/Constantes';

/* Begin By Javi */
import alertify from 'alertifyjs';
import { Loader } from '../util/loader';

/* End By Javi */

const { isMobile } = utils;

const InstallPWA = () => {
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState(null);
  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setSupportsPWA(true);
      setPromptInstall(e);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('transitionend', handler);
  }, []);
  const onClick = (evt) => {
    evt.preventDefault();
    if (!promptInstall) {
      return;
    }
    promptInstall.prompt();
  };
  if (!supportsPWA) {
    return null;
  }
  return (
    <button
      className='btnSubmit'
      id='setup_button'
      aria-label='Install app'
      title='Install app'
      onClick={onClick}
    >
      Install
    </button>
  );
};

export const Login = () => {
  /* Begin By Javi */
  const [Loading, setloading] = useState(false);
  const [_isMobile] = useState(isMobile());
  const [alertMessage, setMessage] = useState('Login UPN');
  /* End By Javi */
  const [loginValue, setLoginValue] = useState({});
  const handleInputChange = (e) => {
    const esValido = e.target.validity.valid;

    if (esValido) {
      setLoginValue({ ...loginValue, [e.target.name]: e.target.value });
    }
  };
  const handleInputPassChange = (e) => {
    setLoginValue({ ...loginValue, [e.target.name]: e.target.value });
  };

  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('./sw.js')
      .then((reg) => '')
      .catch((err) => console.warn('Error al tratar de registrar el sw', err));
  }
  const handleClickCerrar = () => {
    window.close();
  };
  const handleClickIngresar = async () => {
    /* Begin By Javi */
    setloading(true);
    localStorage.removeItem('userLogin');
    /* End By Javi */
    const user = {
      username: loginValue.usuario,
      password: loginValue.contrasenia,
    };
    /* Begin By Javi */
    if (loginValue.usuario == '') {
      setloading(false);
      alertify.alert('Favor ingrese Usuario !').setHeader(alertMessage);
      return;
    } else if (loginValue.contrasenia == '') {
      setloading(false);
      alertify.alert('Favor ingrese Contraseña !').setHeader(alertMessage);
      return;
      /* End By Javi */
    } else {
      /* End By Javi */
      const promise = apiPerfil.listarAttorney(user, alertMessage);
      promise.then((res) => {
        setloading(false);
        if (res != undefined) {
          if (res.detail != null && res.detail != '') {
            if (res.detail.Security != null && res.detail.Security != '') {
              //console.log(JSON.stringify(res));
              localStorage.setItem('userLogin', JSON.stringify(res));
              window.location.href = '/mfa';
            }
          }
        }
      });
    }
  };
  return (
    <section className='row'>
      {Loader(Loading)}
      <div id='branding' className='imgBx'></div>
      <div className='contentBx'>
        <div className='formBx'>
          <img src={Constantes().Imagen.LogoWeb} className='logoBx mb-2'></img>
          <h4 className='mb-5 mt-3'>Hola, bienvenido al Portal de Padres </h4>
          <form>
            <div className='inputBx mb-3'>
              <input
                type='text'
                className='form-control'
                maxLength='8'
                placeholder='Usuario'
                pattern='[0-9]{0,13}'
                value={loginValue.usuario}
                onChange={handleInputChange}
                name='usuario'
              />
            </div>
            <div className='inputBx mb-4'>
              <input
                type='password'
                className='form-control'
                placeholder='Contraseña'
                pattern='[0-9]{0,13}'
                value={loginValue.contrasenia}
                onChange={handleInputPassChange}
                name='contrasenia'
              />
            </div>
            <div className='row'>
              {_isMobile ? (
                <>
                  <div className='inputBx col-12'>
                    <input
                      type='button'
                      className='btnSubmit'
                      value='Ingresar'
                      onClick={handleClickIngresar}
                    />
                  </div>
                </>
              ) : (
                <div className='inputBx col-12'>
                  <input
                    type='button'
                    className='btnSubmit'
                    value='Ingresar'
                    onClick={handleClickIngresar}
                  />
                </div>
              )}
              <div className='inputBx col-12'>
                <p className='float-right'>
                  <Link to='/recuperar-constrasenia'>
                    ¿Olvidó su Contraseña?
                  </Link>
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};
